const getProductsByType = (allProducts, type) => {
  return allProducts
    ? allProducts
        ?.map((item, itemIndex) => ({ ...item, itemIndex: itemIndex }))
        .filter(({ productType }) => +productType === +type)
    : [];
};
export default getProductsByType;
